import React from "react";
import classes from "./Profile.module.css";
import Layout from "../component/Layout";
import SubLayout from "../component/SubLayout";
import Header from "../component/Header";
import BottomNavbar from "../component/BottomNavbar";
import Container from "../component/Container";
import {
  FaFutbol,
  FaArrowRightFromBracket,
  FaPen,
  FaCrown,
  FaFileContract,
  FaTrophy,
  FaCircleQuestion,
  FaBan,
} from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { removeUserDetails } from "../store/slices/userSlice";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { getProfileApi, unsubApi } from "../http/http";
import { useEffect } from "react";
import { toast } from "react-toastify";
import SmallLoader from "../component/SmallLoader";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userDetails } = useSelector((state) => state.persisted?.userSlice);

  const { t } = useTranslation();

  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setProfileLoading(true);
        const response = await getProfileApi(userDetails?.token);
        setProfile(response?.data);
        setProfileLoading(false);
      } catch (error) {
        setProfileLoading(false);
        toast.error(
          error?.response?.data?.error?.error ||
            error?.response?.error?.error ||
            error?.response?.error ||
            t("128"),
        );
      }
    };

    fetchUserProfile();
  }, []);

  const logoutHandler = () => {
    dispatch(removeUserDetails());
    navigate("/");
  };
  const unsubHandler = async () => {
    setLoading(true);
    await unsubApi(userDetails?.token)
      .then((res) => {
        setLoading(false);
        dispatch(removeUserDetails());
        navigate("/");
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.error(t("128"));
      });
  };
  return (
    <Layout>
      <SubLayout>
        <Header active={4} />

        <Container style={{ gap: "30px" }}>
          <div className={classes.profile_section}>
            <p className={classes.profile_header}>{t("115")}</p>
            {profileLoading ? (
              <SmallLoader />
            ) : (
              <div className={classes.profile_sub_section}>
                <div className={classes.profile_avatar}>
                  <img
                    src={profile?.image ?? "/assets/images/dummy.png"}
                    alt={profile?.name ?? "Guest"}
                    className={classes.avatar_image}
                  />
                </div>
                <div className={classes.profile_details}>
                  <p className={classes.profile_text}>
                    {t("116")} {profile?.name ?? "Guest"}
                  </p>
                  <p className={classes.profile_text}>
                    {t("117")} {profile?.id}
                  </p>
                </div>
              </div>
            )}
          </div>

          <button
            type="button"
            className={classes.list_item_container}
            onClick={() => navigate("/edit-profile")}
          >
            <FaPen className={classes.edit_icon} style={{ color: "#4A90E2" }} />
            <p className={classes.list_item_text}>{t("118")}</p>
          </button>

          <button
            type="button"
            className={classes.list_item_container}
            onClick={() => navigate("/subscription-info")}
          >
            <FaCrown
              className={classes.edit_icon}
              style={{ color: "#F5A623" }}
            />
            <p className={classes.list_item_text}>{t("138")}</p>
          </button>

          <button
            type="button"
            className={classes.list_item_container}
            onClick={() => navigate("/my-matches")}
          >
            <FaFutbol
              className={classes.my_matches_icon}
              style={{ color: "#27AE60" }}
            />
            <p className={classes.list_item_text}>{t("119")}</p>
          </button>

          <button
            type="button"
            className={classes.list_item_container}
            onClick={() => navigate("/terms")}
          >
            <FaFileContract
              className={classes.edit_icon}
              style={{ color: "#8E44AD" }}
            />
            <p className={classes.list_item_text}>{t("139")}</p>
          </button>

          <button
            type="button"
            className={classes.list_item_container}
            onClick={() => navigate("/win-history")}
          >
            <FaTrophy
              className={classes.edit_icon}
              style={{ color: "#E67E22" }}
            />
            <p className={classes.list_item_text}>{t("140")}</p>
          </button>

          <button
            type="button"
            className={classes.list_item_container}
            onClick={() => navigate("/faq")}
          >
            <FaCircleQuestion
              className={classes.edit_icon}
              style={{ color: "#16A085" }}
            />
            <p className={classes.list_item_text}>{t("141")}</p>
          </button>

          <button
            type="button"
            className={classes.list_item_container}
            onClick={logoutHandler}
          >
            <FaArrowRightFromBracket
              className={classes.logout_icon}
              style={{ color: "#E74C3C" }}
            />
            <p className={classes.list_item_text}>{t("120")}</p>
          </button>

          <button
            type="button"
            disabled={loading}
            className={classes.list_item_container}
            onClick={unsubHandler}
          >
            {loading ? (
              <SmallLoader style={{ border: "5px solid #fff" }} />
            ) : (
              <>
                <FaBan
                  className={classes.logout_icon}
                  style={{ color: "#95A5A6" }}
                />
                <p className={classes.list_item_text}>{t("142")}</p>
              </>
            )}
          </button>
        </Container>
      </SubLayout>
      {/* <BottomNavbar active={4} /> */}
    </Layout>
  );
};

export default Profile;
